import React, { useState } from 'react';
    import SafeIcon from '../common/SafeIcon';
    import { FiTrash2, FiMenu, FiXCircle } from 'react-icons/fi';

    const ImageList = ({ images, setImages, onRemove, onClearAll }) => {
      const [draggedItemIdx, setDraggedItemIdx] = useState(null);

      const handleDragStart = (e, index) => {
        setDraggedItemIdx(index);
        e.dataTransfer.effectAllowed = "move";
        // Required for Firefox
        e.dataTransfer.setData("text/html", e.currentTarget);
      };

      const handleDragOver = (e, index) => {
        e.preventDefault();
        if (draggedItemIdx === null || draggedItemIdx === index) return;

        const listCopy = [...images];
        const itemToMove = listCopy[draggedItemIdx];
        listCopy.splice(draggedItemIdx, 1);
        listCopy.splice(index, 0, itemToMove);

        setDraggedItemIdx(index);
        setImages(listCopy);
      };

      const handleDragEnd = () => {
        setDraggedItemIdx(null);
      };

      if (images.length === 0) return null;

      return (
        <div className="mt-6 flex flex-col gap-2">
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-sm font-semibold text-gray-600 uppercase tracking-wider">
              Uploaded Images ({images.length})
            </h3>
            <button
              onClick={onClearAll}
              className="flex items-center gap-1 text-xs font-medium text-red-500 hover:text-red-700 transition-colors px-2 py-1 rounded hover:bg-red-50"
              title="Remove all images"
            >
              <SafeIcon icon={FiXCircle} />
              Clear All
            </button>
          </div>
          
          <div className="max-h-[400px] overflow-y-auto pr-2 custom-scrollbar flex flex-col gap-2">
            {images.map((img, idx) => (
              <div
                key={img.id}
                draggable
                onDragStart={(e) => handleDragStart(e, idx)}
                onDragOver={(e) => handleDragOver(e, idx)}
                onDragEnd={handleDragEnd}
                className={`flex items-center gap-3 p-2 bg-white border rounded-lg shadow-sm cursor-move transition-all duration-200
                  ${draggedItemIdx === idx ? 'opacity-40 border-blue-400 bg-blue-50 scale-[0.98]' : 'border-gray-200 hover:shadow-md'}`}
              >
                <div className="text-gray-400 px-1">
                  <SafeIcon icon={FiMenu} />
                </div>
                
                <div className="w-12 h-12 rounded bg-gray-100 flex-shrink-0 overflow-hidden border border-gray-200 pointer-events-none">
                  <img src={img.dataUrl} alt={img.name} className="w-full h-full object-cover" />
                </div>
                
                <div className="flex-1 min-w-0 pointer-events-none">
                  <p className="text-sm font-medium text-gray-700 truncate">{img.name}</p>
                  <p className="text-xs text-gray-400">{Math.round(img.width)} x {Math.round(img.height)}px</p>
                </div>
                
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onRemove(img.id);
                  }}
                  className="p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-md transition-colors"
                  title="Remove image"
                >
                  <SafeIcon icon={FiTrash2} />
                </button>
              </div>
            ))}
          </div>
          <p className="text-[10px] text-gray-400 text-center mt-2 italic">Drag rows to reorder pages</p>
        </div>
      );
    };

    export default ImageList;